import { Brand } from '@blade/std-lib'

export const ImageHashTypeId = 'tradebot-tma/ImageHash'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ImageHashTypeId = typeof ImageHashTypeId

export type ImageHash = Brand.Branded<string, ImageHashTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageHash = Brand.nominal<ImageHash>()
